import { Phone, Mail, ArrowUp } from "lucide-react";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer
      data-testid="footer"
      className="bg-[#040404] text-[#EDE9E1] pt-20 pb-8 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 pb-12 border-b border-[#585857]/30">
          {/* Brand */}
          <div className="md:col-span-2 space-y-4">
            <h3
              data-testid="footer-brand"
              className="font-heading font-black text-3xl tracking-tighter"
            >
              Divya Enterprises
            </h3>
            <p className="text-[#BEBEBD] text-base leading-relaxed max-w-md">
              India's trusted manufacturer of stainless steel yarn conditioning trolleys, ultra high molecular stainless steel castor wheels and stainless steel lycra bobbin trolleys. Engineering excellence since 1998.
            </p>
            <div className="flex items-center gap-6 pt-2">
              <a
                href="tel:+919911414981"
                data-testid="footer-phone"
                className="flex items-center gap-2 text-[#BEBEBD] hover:text-[#EDE9E1] transition-colors"
              >
                <Phone size={14} />
                <span className="text-sm font-medium">+91 9911414981</span>
              </a>
              <a
                href="mailto:divyamukesh_mukeshdivya@yahoo.co.in"
                data-testid="footer-email"
                className="flex items-center gap-2 text-[#BEBEBD] hover:text-[#EDE9E1] transition-colors"
              >
                <Mail size={14} />
                <span className="text-sm font-medium">divyamukesh_mukeshdivya@yahoo.co.in</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.15em] font-bold text-[#BEBEBD] mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Products", href: "#products" },
                // { label: "Testimonials", href: "#testimonials" },
                { label: "Partners", href: "#partners" },
                { label: "Contact", href: "#contact" },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                    className="text-[#BEBEBD] hover:text-[#EDE9E1] transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.15em] font-bold text-[#BEBEBD] mb-6">
              Products
            </h4>
            <ul className="space-y-3">
              <li>
                <span className="text-[#BEBEBD] text-sm">
                  Stainless Steel Yarn Conditioning Trolleys
                </span>
              </li>
              <li>
                <span className="text-[#BEBEBD] text-sm">
                  Ultra High Molecular Stainless Steel Castor Wheels
                </span>
              </li>
              <li>
                <span className="text-[#BEBEBD] text-sm">
                  Stainless Steel Lycra Bobbin Trolleys
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 gap-4">
          <p className="text-[#585857] text-sm">
            &copy; {new Date().getFullYear()} Divya Enterprises. All rights
            reserved.
          </p>
          <button
            onClick={scrollToTop}
            data-testid="footer-scroll-top"
            className="flex items-center gap-2 text-[#BEBEBD] hover:text-[#EDE9E1] transition-colors text-sm group"
          >
            Back to top
            <ArrowUp
              size={14}
              className="group-hover:-translate-y-1 transition-transform"
            />
          </button>
        </div>
      </div>
    </footer>
  );
}
